import {isBase64} from '../../../../common/src/helpers/image/isBase64';

const isBase64DataUrl = value => isBase64(value);

export const sanitizeMetadataValue = value => {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value === 'string') {
    if (isBase64DataUrl(value)) {
      return null;
    }

    return value;
  }

  if (Array.isArray(value)) {
    const sanitized = value
      .map(item => sanitizeMetadataValue(item))
      .filter(item => item !== null && item !== undefined);

    return sanitized.length ? sanitized : null;
  }

  if (typeof value === 'object') {
    const sanitized = Object.entries(value).reduce((acc, [key, item]) => {
      const sanitizedItem = sanitizeMetadataValue(item);
      if (sanitizedItem !== null && sanitizedItem !== undefined) {
        acc[key] = sanitizedItem;
      }
      return acc;
    }, {});

    return Object.keys(sanitized).length ? sanitized : null;
  }

  return value;
};

export const normalisePersonalizationValue = value => {
  if (typeof value === 'string') {
    return value.trim();
  }

  return value;
};

export const isPersonalizationValueExportable = (
  formItem,
  value = formItem?.value
) => {
  if (!formItem) {
    return false;
  }

  const normalisedValue = normalisePersonalizationValue(value);

  if (formItem.type === 'image') {
    if (normalisedValue === null || normalisedValue === undefined) {
      return false;
    }

    if (typeof normalisedValue === 'string') {
      return normalisedValue.length > 0;
    }

    if (typeof normalisedValue === 'object') {
      return Object.keys(normalisedValue).length > 0;
    }

    return true;
  }

  if (typeof normalisedValue === 'string') {
    return normalisedValue.length > 0;
  }

  return normalisedValue !== null && normalisedValue !== undefined;
};
